import React, { Component } from 'react'
import TitleBar from '../TitleBar'
import UserFilterRow from './UserFilterRow.js'
import getLabel from '../../utilities/label.js'
import _ from 'lodash'
import './index.css'

export default class UserFilterScreen extends Component {
  constructor(props){
    super(props)
    this.state = {
      groupNames: this.getGroupList()
    }
  }

  getGroupList() {
    const { users } = this.props
    let groups = users.map((u) => u.user_display_list_attributes)
    return _.uniq(_.flatten(groups).map((g) => g.name))
  }

  toggle(key, secondKey) {
    return () => this.props.toggleFilter(key, secondKey)
  }

  renderSubheader(labelKey) {
    return (
      <div className="filter-subheader">
        { getLabel({ key: labelKey, plural: true}) }
      </div>
    )
  }

  renderGroupSection() {
    return (
      <div>
        { this.renderSubheader('user_display_list') }
        { this.renderGroupFilters() }
      </div>
    )
  }

  renderGroupFilters() {
    const { userFilters } = this.props
    const { groupNames } = this.state
    return _.map(groupNames, (groupName) => {
      return (
        <UserFilterRow
          key={ groupName }
          label={ groupName }
          isChecked={ userFilters.groups[groupName] }
          onChange={ this.toggle('groups', groupName) } />
      )
    })
  }

  render() {
    const { userFilters } = this.props
    const { groupNames } = this.state
    var groupCount = groupNames.length > 1 ? groupNames.length : ''
    const backButton = '<i class=\'fa fa-arrow-left\'></i> ' + getLabel('back_button')
    return (
      <div>
        <TitleBar
          title={ getLabel('filter') }
          leftButtonLabel={ backButton }
          leftButtonAction={ this.props.toggleFilterScreen }
          rightButtonLabel={ getLabel('reset_filter') }
          rightButtonAction={ this.props.resetFilters } />
        <UserFilterRow
          label={ getLabel({ key: 'connection', plural: true }) }
          isChecked={ userFilters['connections'] }
          onChange={ this.toggle('connections') } />
        <UserFilterRow
          label={ getLabel({ key: 'speaker', plural: true }) }
          isChecked={ userFilters['speakers'] }
          onChange={ this.toggle('speakers') } />
        <UserFilterRow
          label={ getLabel({ key: 'sponsor', plural: true }) }
          isChecked={ userFilters['sponsors'] }
          onChange={ this.toggle('sponsors') } />
        { groupCount && this.renderGroupSection() }

      </div>
    )
  }
}
